import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HardwareSelfServiceService } from "@/services/hardware-self-service/hardware-self-service-service";
import { HSS_STATUS_QUERY_KEY } from "@/hooks/use-hss-status";
import type { SubmitResponsesOutput } from "@amzn/hardware-self-service-api-model";
import type { SubmitResponsesRequest } from "@/services/hardware-self-service/hardware-self-service.types";

const hardwareSelfServiceService = new HardwareSelfServiceService();

export const useSubmitHssResponses = () => {
  const queryClient = useQueryClient();

  return useMutation<SubmitResponsesOutput, Error, SubmitResponsesRequest>({
    mutationFn: (request) => hardwareSelfServiceService.submitResponses(request),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: HSS_STATUS_QUERY_KEY }),
    onError: () => queryClient.invalidateQueries({ queryKey: HSS_STATUS_QUERY_KEY }),
  });
};
